import { alarmFieldsState } from '../state/alarmFieldsState';
import { Fetch_All_Region_Data1,GET_ALARM_FIELDS_REQUEST, GET_ALARM_FIELDS_SUCCESS, UPDATE_ALARM_FIELDS_SUCCESS,
        GET_PREDEFINED_TEXT_LIST_SUCCESS} from '../action/alarmFieldsAction';

export function AlarmFieldsReducer(state = alarmFieldsState, action) {
    switch(action.type){
        case GET_ALARM_FIELDS_REQUEST:
            return Object.assign({}, state, {
                errorCode : 0,
                statusCode : 0,
                message : '',
                isLoading : action.isLoading
            })
        case GET_ALARM_FIELDS_SUCCESS:
            return Object.assign({},state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                alarmDataList : action.list,
                isLoading : action.isLoading
            })
        case UPDATE_ALARM_FIELDS_SUCCESS:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                alarmDataList : action.list,
                isLoading : action.isLoading,
                message : action.message
            })
        case GET_PREDEFINED_TEXT_LIST_SUCCESS:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                isLoading : action.isLoading,
                predefinedTextList : action.list
            })
             case Fetch_All_Region_Data1:
                                                        return Object.assign({}, state, {
                                                            errorCode : action.errorCode,
                                                            statusCode : action.statusCode,
                                                            regionList : action.regionList
                                                        })
        default:
            return state
    }
}